{
  "{account} needs to sign in again.": "Tilin {account} pitää kirjautua uudelleen.",
  "{account} no longer has access to Johku Hub.": "Tilillä {account} ei ole enää pääsyä Johku Hubiin.",
  "{done} of {total}": "{done}/{total}",
  "{left} of {total} left": "{left} / {total} jäljellä",
  "{n} by email": "{n} sähköpostilla",
  "{n} by push": "{n} ilmoituksena",
  "{n} customer waiting for a reply": "{n} asiakas odottaa vastausta",
  "{n} customers waiting for a reply": "{n} asiakasta odottaa vastausta",
  "{n} message": "{n} viesti",
  "{n} message hasn't been sent yet and will be lost.": "{n} viesti on vielä lähettämättä ja katoaa.",
  "{n} messages": "{n} viestiä",
  "{n} messages haven't been sent yet and will be lost.": "{n} viestiä on vielä lähettämättä ja katoaa.",
  "{n} more: search by name.": "{n} lisää: hae nimellä.",
  "{n} of {total}": "{n}/{total}",
  "{n} pcs": "{n} kpl",
  "{n} shop chosen": "{n} kauppa valittu",
  "{n} shops chosen": "{n} kauppaa valittu",
  "{n} ticket": "{n} lippu",
  "{n} tickets": "{n} lippua",
  "{n} unread": "{n} lukematonta",
  "{n} unread conversation": "{n} lukematon keskustelu",
  "{n} unread conversations": "{n} lukematonta keskustelua",
  "{n} use left": "{n} käyttökerta jäljellä",
  "{n} uses left": "{n} käyttökertaa jäljellä",
  "{name} ({n} member)": "{name} ({n} jäsen)",
  "{name} ({n} members)": "{name} ({n} jäsentä)",
  "{name} and {n} more": "{name} ja {n} muuta",
  "{name} sent you a message in Johku Hub ({subject}).": "{name} lähetti sinulle viestin Johku Hubissa ({subject}).",
  "{name} sent you a message in Johku Hub.": "{name} lähetti sinulle viestin Johku Hubissa.",
  "{shop} can sell its products in your sales channel. Once they accept, Johku puts it into effect.": "{shop} voi myydä tuotteitaan myyntikanavassasi. Kun he hyväksyvät, Johku ottaa sen käyttöön.",
  "{shop} sent you a message about your order {order}.": "{shop} lähetti sinulle viestin tilauksestasi {order}.",
  "{shop} would like to talk with you. Reply or accept to continue.": "{shop} haluaa keskustella kanssanne. Vastaa tai hyväksy jatkaaksesi.",
  "Accept": "Hyväksy",
  "Accepted the offer: {channel}, {commission} % commission.": "Hyväksyi tarjouksen: {channel}, komissio {commission} %.",
  "Accepted, being put into effect in Johku": "Hyväksytty, otetaan käyttöön Johkussa",
  "Accepted, but Johku couldn't put it into effect: {error}": "Hyväksytty, mutta Johku ei voinut ottaa sitä käyttöön: {error}",
  "Accepted, in effect in Johku": "Hyväksytty, käytössä Johkussa",
  "Access and instructions": "Käyttöönotto-ohjeet",
  "Accounts": "Tilit",
  "Accounts and settings": "Tilit ja asetukset",
  "Add account": "Lisää tili",
  "Add an account": "Lisää tili",
  "All": "Kaikki",
  "All caught up": "Kaikki luettu",
  "All incidents": "Kaikki häiriöt",
  "All orders": "Kaikki tilaukset",
  "All shops": "Kaikki kaupat",
  "All your shops ({n})": "Kaikki kauppasi ({n})",
  "Allow": "Salli",
  "Allow {app} to use Johku Hub?": "Annetaanko sovellukselle {app} pääsy Johku Hubiin?",
  "an assistant": "avustaja",
  "An assistant asks to use your Johku Hub conversations. Sign in first.": "Avustaja pyytää pääsyä Johku Hubin keskusteluihisi. Kirjaudu ensin sisään.",
  "As {name}": "{name} nimissä",
  "Ask the shop": "Kysy kaupalta",
  "Attach a file": "Liitä tiedosto",
  "Back": "Takaisin",
  "Between organisations": "Organisaatioiden välillä",
  "Booking": "Varaus",
  "Can't load the collections right now.": "Kokoelmia ei voi ladata juuri nyt.",
  "Can't load the list of organisations right now.": "Organisaatioita ei saatu juuri nyt haettua.",
  "Can't reach Johku Hub. Check your connection and try again.": "Johku Hubiin ei saada yhteyttä. Tarkista yhteys ja yritä uudelleen.",
  "Cancel": "Peruuta",
  "Cancelled": "Peruutettu",
  "Cause found, being fixed": "Syy löytynyt, korjataan",
  "Choose a conversation": "Valitse keskustelu",
  "Chosen shops": "Valituille kaupoille",
  "Close": "Sulje",
  "Code sent to {email}": "Koodi lähetettiin osoitteeseen {email}",
  "Codes": "Koodit",
  "Commission (%)": "Komissio (%)",
  "Confirmed": "Vahvistettu",
  "Conversation": "Keskustelu",
  "Conversations with the Johku team and shops show up here.": "Keskustelut Johkun ja kauppojen kanssa näkyvät täällä.",
  "Copied": "Kopioitu",
  "Copy the code": "Kopioi koodi",
  "customer": "asiakas",
  "Customer": "Asiakas",
  "Decline": "Hylkää",
  "Declined": "Hylätty",
  "Declined the offer.": "Hylkäsi tarjouksen.",
  "Deny": "Älä salli",
  "Done": "Valmis",
  "Download": "Lataa",
  "Downloading {name}": "Ladataan: {name}",
  "E.g. Card payments fail": "Esim. Korttimaksut eivät toimi",
  "Each member gets it in a conversation of their own with the shop, and their replies come to you one by one.": "Jokainen jäsen saa viestin omaan keskusteluunsa kaupan kanssa, ja heidän vastauksensa tulevat sinulle kukin erikseen.",
  "Email address": "Sähköpostiosoite",
  "Email those who don't have the app": "Lähetä sähköposti niille, joilla ei ole sovellusta",
  "Event times, cancellations and the shop's replies.": "Tapahtumien ajat, peruutukset ja kaupan vastaukset.",
  "Every shop": "Kaikille kaupoille",
  "Everything you've bought from Johku shops, in one place.": "Kaikki Johku-kaupoista ostamasi samassa paikassa.",
  "Expired {date}": "Vanhentui {date}",
  "Find a shop": "Etsi kauppa",
  "Fixed, monitoring": "Korjattu, seurataan",
  "For": "Kenelle",
  "For every shop": "Kaikille kaupoille",
  "For: {shops}": "Kenelle: {shops}",
  "Get started": "Aloitus",
  "Get told about new messages": "Saat ilmoituksen uusista viesteistä",
  "Getting the tickets…": "Haetaan lippuja…",
  "Gift cards and other codes you buy from Johku shops show up here.": "Johku-kaupoista ostamasi lahjakortit ja muut koodit näkyvät täällä.",
  "Hide": "Piilota",
  "Hide used and expired codes": "Piilota käytetyt ja vanhentuneet koodit",
  "Home": "Koti",
  "In messages": "Viesteissä",
  "Incidents": "Häiriöt",
  "Incidents in Johku": "Häiriöt Johkussa",
  "Investigating": "Selvitetään",
  "It is valid for 10 minutes. If you didn't ask for it, you can ignore this email.": "Se on voimassa 10 minuuttia. Jos et pyytänyt sitä, voit jättää tämän viestin huomiotta.",
  "It opens signed in, and stays open in the background": "Aukeaa valmiiksi kirjautuneena ja pysyy auki taustalla",
  "It sees only what you see in Johku Hub, and every use is logged.": "Se näkee vain sen, minkä sinäkin näet Johku Hubissa, ja jokainen käyttökerta kirjataan.",
  "Johku account": "Johku-tili",
  "Johku App": "Johku App",
  "Johku Hub isn't working right now. Try again in a moment.": "Johku Hub ei toimi juuri nyt. Yritä hetken päästä uudelleen.",
  "Johku Hub sign-in code: {code}": "Johku Hubin kirjautumiskoodi: {code}",
  "Johku status: {title}": "Johkun tilanne: {title}",
  "Kind of conversation": "Keskustelun tyyppi",
  "Know when things change": "Tiedät, kun jokin muuttuu",
  "Language": "Kieli",
  "Loading…": "Haetaan…",
  "Main menu": "Päävalikko",
  "Maintenance": "Huoltokatko",
  "Make an offer": "Tee tarjous",
  "Members of": "Kokoelman jäsenet",
  "Members' replies come as conversations of their own.": "Jäsenten vastaukset tulevat omina keskusteluinaan.",
  "Message": "Viesti",
  "Message (optional)": "Viesti (valinnainen)",
  "Message the seller about your order and get told when they reply.": "Lähetä myyjälle viesti tilauksestasi ja saat ilmoituksen, kun hän vastaa.",
  "Message to the shops": "Viesti kaupoille",
  "Messages": "Viestit",
  "Messages can't be reached right now.": "Viestit eivät ole juuri nyt saatavilla.",
  "My Johku": "Oma Johku",
  "Name, sign-in and deleting the account": "Nimi, kirjautuminen ja tilin poistaminen",
  "New conversation": "Uusi keskustelu",
  "New incident": "Uusi häiriö",
  "New message from {name} in Johku Hub": "Uusi viesti Johku Hubissa: {name}",
  "New message from {shop}": "Uusi viesti: {shop}",
  "New message: {shop}, order {order}": "Uusi viesti: {shop}, tilaus {order}",
  "New messages in Johku Hub": "Uudet viestit Johku Hubissa",
  "Next up": "Seuraavaksi",
  "No conversations yet": "Ei vielä keskusteluja",
  "No conversations yet. Start one with the pen above.": "Ei vielä keskusteluja. Aloita uusi yläreunan kynästä.",
  "No email? It can take a minute. Check the spam folder too.": "Eikö viestiä näy? Se voi viipyä hetken. Katso myös roskapostikansio.",
  "No incidents in the last 30 days.": "Ei häiriöitä viimeisten 30 päivän aikana.",
  "No matches.": "Ei osumia.",
  "No messages about this order yet. The customer gets an email with a link to the order page, where they can read and reply.": "Tästä tilauksesta ei ole vielä viestejä. Asiakas saa sähköpostin, jossa on linkki tilaussivulle. Siellä hän voi lukea viestin ja vastata.",
  "No messages yet": "Ei vielä viestejä",
  "No messages yet.": "Ei vielä viestejä.",
  "No valid codes": "Ei voimassa olevia koodeja",
  "None of the shop's collections has members yet.": "Kaupan kokoelmissa ei ole vielä jäseniä.",
  "Not sent: {error}": "Ei lähetetty: {error}",
  "Not shown yet": "Ei vielä näkyvissä",
  "Not working": "Ei toimi",
  "Nothing matches “{query}”.": "Haulla ”{query}” ei löytynyt mitään.",
  "Notice": "Tiedote",
  "Notifications are blocked for this site in the browser's settings.": "Ilmoitukset on estetty tältä sivustolta selaimen asetuksissa.",
  "Notifications are off for Johku Hub in the phone's settings.": "Johku Hubin ilmoitukset ovat pois päältä puhelimen asetuksissa.",
  "Notifications of new messages: {name}": "Ilmoitukset uusista viesteistä: {name}",
  "Now": "Nyt",
  "Offer a sales channel": "Tarjoa myyntikanavaa",
  "Offer: sell your products in {channel} with a {commission} % commission.": "Tarjous: myykää tuotteitanne myyntikanavassa {channel} {commission} %:n komissiolla.",
  "Offline": "Ei yhteyttä",
  "Offline. {n} message will send when the connection returns.": "Ei yhteyttä. {n} viesti lähtee, kun yhteys palaa.",
  "Offline. {n} messages will send when the connection returns.": "Ei yhteyttä. {n} viestiä lähtee, kun yhteys palaa.",
  "Offline. Messages will send when the connection returns.": "Ei yhteyttä. Viestit lähtevät, kun yhteys palaa.",
  "Offline. These are the codes saved on this phone ({time}).": "Ei yhteyttä. Nämä ovat puhelimeen tallennetut koodit ({time}).",
  "Offline. These are the orders saved on this phone.": "Ei yhteyttä. Nämä ovat puhelimeen tallennetut tilaukset.",
  "Offline. These are the tickets saved on this phone ({time}).": "Ei yhteyttä. Nämä ovat puhelimeen tallennetut liput ({time}).",
  "OK": "OK",
  "One use": "Yksi käyttökerta",
  "Open Johku App": "Avaa Johku App",
  "Open the order": "Avaa tilaus",
  "Open the order in the shop": "Avaa tilaus kaupassa",
  "Opening…": "Avataan…",
  "Opens in a new tab": "Aukeaa uuteen välilehteen",
  "Order": "Tilaus",
  "Order {id}": "Tilaus {id}",
  "Orders": "Tilaukset",
  "Other merchants": "Muut kauppiaat",
  "Other merchants find {shop}": "Muut kauppiaat löytävät kaupan {shop}",
  "Other orders": "Muut tilaukset",
  "Paid": "Maksettu",
  "Partly working": "Toimii osittain",
  "Pictures, PDF, text, Word and Excel files only": "Vain kuvia, PDF-, teksti-, Word- ja Excel-tiedostoja",
  "PIN code": "PIN-koodi",
  "PIN codes": "PIN-koodit",
  "Private message": "Yksityisviesti",
  "Read and reply: {url}": "Lue ja vastaa: {url}",
  "Read and search your conversations": "Lukea ja hakea keskustelujasi",
  "Recent": "Viimeisimmät",
  "Recipient": "Vastaanottaja",
  "Refunded": "Hyvitetty",
  "Reload": "Päivitä",
  "Remove": "Poista",
  "Reply in the Johku app or at {url}, signed in with this email address.": "Vastaa Johku-sovelluksessa tai osoitteessa {url} tällä sähköpostiosoitteella kirjautuneena.",
  "Resolved": "Ratkaistu",
  "Resolved: {title}": "Ratkaistu: {title}",
  "Row {row}, seat {seat}": "Rivi {row}, paikka {seat}",
  "Sales channel offer": "Myyntikanavatarjous",
  "Save": "Tallenna",
  "Saved in Downloads": "Tallennettu Latauksiin",
  "Saving files needs Android 10 or newer": "Tiedostojen tallentaminen vaatii Android 10:n tai uudemman",
  "Search": "Haku",
  "Search by name": "Hae nimellä",
  "Search conversations": "Hae keskusteluista",
  "Seat {seat}": "Paikka {seat}",
  "See all": "Näytä kaikki",
  "Sell, check tickets and answer customers in Johku App.": "Myy, tarkasta lippuja ja vastaa asiakkaille Johku Appissa.",
  "Send": "Lähetä",
  "Send as": "Lähettäjä",
  "Send code": "Lähetä koodi",
  "Send messages and start conversations as you": "Lähettää viestejä ja aloittaa keskusteluja puolestasi",
  "Send now": "Lähetä nyt",
  "Send the offer": "Lähetä tarjous",
  "Send to members": "Lähetä jäsenille",
  "Send to shops": "Lähetä kaupoille",
  "Send update": "Lähetä tiedote",
  "Sending…": "Lähetetään…",
  "Sent to {done} of {n} people": "Lähetetty {done}/{n} henkilölle",
  "Sent to {done} of {n} person": "Lähetetty {done}/{n} henkilölle",
  "Severity": "Vakavuus",
  "Shop": "Kauppa",
  "Show booking": "Näytä varaus",
  "Show conversations of": "Näytä keskustelut",
  "Show more": "Näytä lisää",
  "Show orders of": "Näytä tilaukset kaupasta",
  "Show the code at the door.": "Näytä koodi ovella.",
  "Show the code at the till, or type it in the shop's online store.": "Näytä koodi kassalla tai syötä se kaupan verkkokaupassa.",
  "Show tickets": "Näytä liput",
  "Show used and expired codes": "Näytä käytetyt ja vanhentuneet koodit",
  "Sign in": "Kirjaudu sisään",
  "Sign in again": "Kirjaudu sisään uudelleen",
  "Sign in to Johku Hub": "Kirjaudu Johku Hubiin",
  "Sign in with an email code": "Kirjaudu sähköpostikoodilla",
  "Sign in with Johku": "Kirjaudu Johku-tilillä",
  "Sign out": "Kirjaudu ulos",
  "Sign out of {email}? Its messages are removed from this device.": "Kirjaudutaanko ulos tililtä {email}? Sen viestit poistetaan tältä laitteelta.",
  "Sign out of this account": "Kirjaudu ulos tältä tililtä",
  "Sign out?": "Kirjaudutaanko ulos?",
  "Signing in with Johku didn't finish. Please try again.": "Kirjautuminen Johku-tilillä jäi kesken. Yritä uudelleen.",
  "Signing in with Johku didn't work ({error}).": "Kirjautuminen Johku-tilillä ei onnistunut ({error}).",
  "Signing in…": "Kirjaudutaan…",
  "So you see customers' questions right away": "Näet asiakkaiden kysymykset heti",
  "Some shops didn't answer, so their codes may be missing: {shops}": "Kaikki kaupat eivät vastanneet, joten niiden koodeja voi puuttua: {shops}",
  "Someone": "Joku",
  "Something went wrong.": "Jokin meni vikaan.",
  "Something went wrong. Please try again.": "Jotain meni pieleen. Yritä uudelleen.",
  "Start the conversation": "Aloita keskustelu",
  "Status": "Tila",
  "Subject (optional)": "Aihe (valinnainen)",
  "Swipe for the next one": "Pyyhkäise seuraavaan",
  "Switch shop": "Vaihda kauppaa",
  "That code has expired. Ask for a new one.": "Koodi on vanhentunut. Pyydä uusi.",
  "That code isn't right. Check it and try again.": "Koodi ei ole oikein. Tarkista se ja yritä uudelleen.",
  "The code is on its way. Check again in a moment.": "Koodi on tulossa. Katso hetken päästä uudelleen.",
  "The conversation was declined.": "Keskustelu hylättiin.",
  "The download failed": "Lataus epäonnistui",
  "The file is larger than 20 MB": "Tiedosto on yli 20 Mt",
  "The Johku team": "Johkun tiimi",
  "The Johku team keeps you posted here until it's resolved.": "Johkun tiimi kertoo tilanteesta täällä, kunnes häiriö on ratkaistu.",
  "The order page can't be opened right now. Try again in a moment.": "Tilauksen sivua ei saada juuri nyt auki. Yritä hetken päästä uudelleen.",
  "The phone's language": "Puhelimen kieli",
  "The PIN code and instructions show from {time}.": "PIN-koodi ja ohjeet näkyvät {time} alkaen.",
  "The tickets can't be opened right now. Try again in a moment.": "Lippuja ei saada juuri nyt auki. Yritä hetken päästä uudelleen.",
  "There's no one {name} can write to yet.": "Organisaatiolla {name} ei ole vielä ketään, jolle kirjoittaa.",
  "These tickets aren't available any more.": "Nämä liput eivät ole enää saatavilla.",
  "this account": "tämä tili",
  "This goes now to the staff of {n} shop, by push and email. Send it?": "Tämä lähtee nyt {n} kaupan henkilökunnalle ilmoituksena ja sähköpostina. Lähetetäänkö?",
  "This goes now to the staff of {n} shops, by push and email. Send it?": "Tämä lähtee nyt {n} kaupan henkilökunnalle ilmoituksena ja sähköpostina. Lähetetäänkö?",
  "This goes now to the staff of every shop, by push and email. Send it?": "Tämä lähtee nyt kaikkien kauppojen henkilökunnalle ilmoituksena ja sähköpostina. Lähetetäänkö?",
  "This incident isn't shown any more.": "Tätä häiriötä ei enää näytetä.",
  "This order has been cancelled. Its tickets aren't valid.": "Tilaus on peruttu. Sen liput eivät ole voimassa.",
  "This order has been refunded. Its tickets aren't valid.": "Tilaus on hyvitetty. Sen liput eivät ole voimassa.",
  "Ticket": "Lippu",
  "Ticket {n} of {total}": "Lippu {n}/{total}",
  "Tickets": "Liput",
  "Tickets at hand": "Liput aina mukana",
  "To (email)": "Vastaanottaja (sähköposti)",
  "To members": "Jäsenille",
  "To the members of {collection}: {n} member": "Kokoelman {collection} jäsenille: {n} jäsen",
  "To the members of {collection}: {n} members": "Kokoelman {collection} jäsenille: {n} jäsentä",
  "To the members of {collection}: sending, {sent}/{n}": "Kokoelman {collection} jäsenille: lähetetään, {sent}/{n}",
  "Today": "Tänään",
  "Total": "Yhteensä",
  "Turn on notifications": "Ota ilmoitukset käyttöön",
  "Unpaid": "Ei maksettu",
  "Upcoming": "Tulevat",
  "Update to the shops": "Tilannetiedote kaupoille",
  "Use another address": "Käytä toista osoitetta",
  "Used": "Käytetty",
  "Uses": "Käyttökertoja",
  "Valid from {date}": "Voimassa {date} alkaen",
  "Valid until {date}": "Voimassa {date} asti",
  "Validity": "Voimassaolo",
  "Value left": "Arvoa jäljellä",
  "Venue": "Paikka",
  "Waiting for {shop} to accept the conversation.": "Odotetaan, että {shop} hyväksyy keskustelun.",
  "Waiting for an answer": "Odottaa vastausta",
  "We'll email you a sign-in code. Use the address you use with Johku.": "Lähetämme kirjautumiskoodin sähköpostiisi. Käytä osoitetta, jota käytät Johkussa.",
  "What doesn't work, who it concerns, what to do meanwhile.": "Mikä ei toimi, ketä se koskee ja mitä sillä välin voi tehdä.",
  "What you offer, and what kind of partners you look for": "Mitä tarjoatte ja millaisia kumppaneita etsitte",
  "What's wrong": "Mikä ei toimi",
  "When": "Aika",
  "When something in Johku doesn't work, and when it's fixed": "Kun jokin Johkussa ei toimi, ja kun se on korjattu",
  "When you buy from a Johku shop with {email}, the order appears here on its own.": "Kun ostat Johku-kaupasta osoitteella {email}, tilaus näkyy täällä automaattisesti.",
  "When you buy from a Johku shop with your email, the order appears here on its own.": "Kun ostat Johku-kaupasta sähköpostiosoitteellasi, tilaus tulee tänne itsestään.",
  "Whether other Johku merchants find your shop and can invite it to a conversation": "Löytävätkö muut Johku-kauppiaat kauppasi ja voivatko he kutsua sen keskusteluun",
  "With the customer": "Asiakkaan kanssa",
  "With your email, Google or Microsoft, as in Johku's online shops.": "Sähköpostilla, Googlella tai Microsoftilla, kuten Johku-verkkokaupoissa.",
  "Withdraw the offer": "Peru tarjous",
  "Withdrawn": "Peruttu",
  "Withdrew the offer.": "Perui tarjouksen.",
  "Write to the customer": "Kirjoita asiakkaalle",
  "Write to the shop": "Kirjoita kaupalle",
  "Yesterday": "Eilen",
  "You": "Sinä",
  "You can close this page.": "Voit sulkea tämän sivun.",
  "You get this because you work for a shop on Johku. Follow the situation in the Johku app or at {url}.": "Saat tämän, koska työskentelet Johkua käyttävässä kaupassa. Seuraa tilannetta Johku-sovelluksessa tai osoitteessa {url}.",
  "You: ": "Sinä: ",
  "You'll see replies without opening the app.": "Näet vastaukset avaamatta sovellusta.",
  "You're offline. A new conversation needs a connection.": "Ei yhteyttä. Uuden keskustelun aloittaminen vaatii yhteyden.",
  "You're offline. The first message needs a connection.": "Ei yhteyttä. Ensimmäisen viestin lähettäminen vaatii yhteyden.",
  "You're offline. Try again when the connection returns.": "Ei verkkoyhteyttä. Yritä uudelleen, kun yhteys palaa.",
  "You're staff at {shop}": "Kuulut kaupan {shop} henkilökuntaan",
  "Your codes can't be loaded right now. Try again in a moment.": "Koodeja ei saada juuri nyt ladattua. Yritä hetken päästä uudelleen.",
  "Your conversations with shops about your orders show up here.": "Keskustelusi kauppojen kanssa tilauksistasi näkyvät täällä.",
  "Your Johku account doesn't have access to Johku Hub yet.": "Johku-tililläsi ei ole vielä pääsyä Johku Hubiin.",
  "Your Johku Hub sign-in code is {code}.": "Johku Hubin kirjautumiskoodisi on {code}.",
  "Your orders": "Tilauksesi",
  "Your orders can't be loaded right now. Try again in a moment.": "Tilauksia ei saada juuri nyt ladattua. Yritä hetken päästä uudelleen.",
  "Your other accounts stay signed in.": "Muut tilisi pysyvät kirjautuneina.",
  "Your other accounts stay signed in. Switch between them from your picture on Home.": "Muut tilisi pysyvät kirjautuneina. Vaihda tiliä Kodin oikean yläkulman kuvasta.",
  "Your session for {account} has ended. Please sign in again.": "Tilin {account} istunto on päättynyt. Kirjaudu uudelleen.",
  "Your shop": "Kauppasi",
  "Your shop has no sales channel in Johku. Set one up in the Johku app's settings first.": "Kaupallasi ei ole myyntikanavaa Johkussa. Ota se ensin käyttöön Johku-sovelluksen asetuksissa.",
  "Your shops": "Kauppasi",
  "Your tickets will show up here": "Lippusi näkyvät täällä",
  "Your tickets, orders and messages with shops": "Lippusi, tilauksesi ja viestisi kauppojen kanssa"
}
